import type { BookEventFormValues } from './BookingEvent'
import type { EventLocation, ParsedBookableEvent } from './types'

export type CheckoutRestoreUpdates = {
    bookingEvent: ParsedBookableEvent
    bookingData: BookEventFormValues
    overviewSelectedLocation: EventLocation | null
    state: 'payment'
}

export function buildCheckoutRestoreUpdates(pending: {
    bookingEvent: ParsedBookableEvent
    bookingData: BookEventFormValues
}): CheckoutRestoreUpdates {
    return {
        bookingEvent: pending.bookingEvent,
        bookingData: pending.bookingData,
        overviewSelectedLocation: pending.bookingData.selectedLocation ?? null,
        state: 'payment'
    }
}
